import Enumeration from 'Lib/utilities/Enumeration';

const ProcessingFeeTypes = new Enumeration([
    { id: 1, key: 'Manager', name: 'I will pay the fee' },
    { id: 2, key: 'Tenant', name: 'Tenant pays the fee' }
]);

export default ProcessingFeeTypes;
